<div class="footer">
  <section class="footer-slider footer_top">


    <div class="container flex-container overflow-hidden">
      <div class="row">
        <div class="col-md-12">
          <div class="photobanner">
            <div class="justify-content-center gov_logos" *ngFor="let footers of footerImgList">
              <cbic-link [linkEn]="footers.refNumber">
                <div class="our_client_card overflow-hidden shadow-sm">
                  <img src='content/anotherfile/media/{{footers.path}}' title="{{footers.titleEn}}"
                    alt="{{footers.titleEn}}" class="img-fluid zoom-in-out-box" width="100%" height="80px">
                </div>
              </cbic-link>
            </div>
          </div>
        </div>
      </div>
    </div>




    <!-- <div class="container-fluid flex-container">
      <div class="justify-content-center gov_logos" *ngFor="let footers of footerImgList">
        <div class="overflow-hidden shadow-sm our_client_card">
          <cbic-link [linkEn]="footers.refNumber">
            <img src="content/anotherfile/media/{{footers.path}}" type='application/image' title="{{footers.titleEn}}" alt="{{footers.titleEn}}" class="img-fluid zoom-in-out-box" width="" height="">
          </cbic-link>
        </div>
      </div>
    </div> -->


    <!-- <div class="container">
      <div class="row align-items-center justify-content-center ">
          <div class="col-md-2 justify-content-center py-2" *ngFor="let footers of footerImgList">
            <div class="overflow-hidden shadow-sm our_client_card">
              <cbic-link  [linkEn]="footers.refNumber">
                <img src='content/images/{{footers.path}}.png' title="{{footers.titleEn}}" alt="{{footers.titleEn}}" class="img-fluid zoom-in-out-box">
              </cbic-link>
            </div>
          </div>
      </div>
    </div> -->
  </section>


  <div class="footer_middle footer-link py-2">
    <div class="container">
      <div class="row">
        <div class="col-md-10">
          <h5 class="border-bottom"><b cbicTranslate="menu.UsefulLinks"></b></h5>

          <ul class="p-0 mb-0">
            <div *ngIf="flag==='Hi'" class='row pb-3'>
              <li class="col-lg-4 col-md-6 col-sm-6" *ngFor="let usefulLink of usefulUrlList"><a
                  href="{{usefulLink.path}}" target="_blank">{{usefulLink.titleHi}}&nbsp;
                  <i class="external-link" aria-hidden="true"></i></a>
              </li>
            </div>

            <div *ngIf="flag==='En'" class='row pb-3'>
              <div class="col-lg-4 col-md-6 col-sm-6">
                <li *ngFor="let usefulLink of usefulUrlList?.slice(0,7)"><a href="{{usefulLink.path}}"
                    target="_blank">{{usefulLink.titleEn}}&nbsp;
                    <i class="external-link" aria-hidden="true"></i></a>
                </li>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6">

                <li *ngFor="let usefulLink of usefulUrlList?.slice(7,14)"><a href="{{usefulLink.path}}"
                    target="_blank">{{usefulLink.titleEn}}&nbsp;
                    <i class="external-link" aria-hidden="true"></i></a>
                </li>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6">

                <li *ngFor="let usefulLink of usefulUrlList?.slice(14,22)"><a href="{{usefulLink.path}}"
                    target="_blank">{{usefulLink.titleEn}}&nbsp;
                    <i class="external-link" aria-hidden="true"></i></a>
                </li>
              </div>

            </div>
          </ul>



          <!-- <ul class="p-0 mb-0">
            <div *ngIf="flag==='Hi'" class='row pb-3'>
              <li class="col-lg-4 col-md-6 col-sm-6" *ngFor="let usefulLink of usefulUrlList"><a
                  href="{{usefulLink.path}}" target="_blank">{{usefulLink.titleHi}}&nbsp;
                  <i class="external-link" aria-hidden="true"></i></a>
              </li>
            </div>
            <div *ngIf="flag==='En'" class='row pb-3'>
              <li class="col-lg-4 col-md-6 col-sm-6" *ngFor="let usefulLink of usefulUrlList"><a
                  href="{{usefulLink.path}}" target="_blank">{{usefulLink.titleEn}}&nbsp;
                  <i class="external-link" aria-hidden="true"></i></a>
              </li>
            </div>
          </ul> -->
        </div>
        <div class="col-md-2">
          <h5 class="border-bottom"><b cbicTranslate="menu.ContactUs"></b></h5>

          <ul *ngIf="flag==='En'" class="p-0 mb-0">
            <li *ngFor="let contactUs of contactUsList">
              <a href="{{contactUs.path}}">
                <span class="FontWhite">{{contactUs.titleEn}}</span>
              </a>
            </li>
          </ul>
          <ul *ngIf="flag==='Hi'" class="p-0 mb-0">
            <li *ngFor="let contactUs of contactUsList">
              <a href="{{contactUs.path}}">
                <span class="FontWhite">{{contactUs.titleHi}}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>


      <div class="container border-top py-1 noPadding">
        <div class="row">
          <div class="col-md-6">
            <ul class="p-0 mb-0">
              <li class="first">
                <span class="FontWhite" cbicTranslate="menu.Visitor">&nbsp;&nbsp;</span>
                <span class="numCounter letterspacing-visitorcount noPadding">&nbsp;:&nbsp;{{visiterCount}} </span>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="p-0 mb-0">
              <li *ngFor="let websitePolicy of websitePolicyList">
                <a href="/entities/website-policy/who-we-are.html">
                  <span class="Font White" cbicTranslate="menu.WebsitePolicy">&nbsp;&nbsp;</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>


    </div>
  </div>

  <!--<mat-divider *ngIf="color === 'pur'"></mat-divider>
  <mat-divider class="grey-bg" *ngIf="color === 'bule'"></mat-divider>--->

  <mat-divider></mat-divider>

  <div class="footer_lower text-center p-1 small">
    <span class="FontWhite" cbicTranslate="menu.FooterNotification">&nbsp;&nbsp;</span>
  </div>